import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import React from 'react';
import { TouchableOpacity, StyleSheet, ViewStyle } from 'react-native';
import Ionicons from '@expo/vector-icons/Ionicons';

type Props = {
  customStyles?: ViewStyle;
  onAdd?: any;
};

const styles = StyleSheet.create({
  addButton: {
    position: 'absolute',
    right: -8,
    top: 5,
    zIndex: 2,
  },
});

const AddProductTile: React.FC<Props> = ({ customStyles, onAdd }) => (
  <TouchableOpacity testID="btnAddProduct" onPress={onAdd} style={[styles.addButton, customStyles]}>
    <Ionicons name="add-circle" size={scale(22)} color={colors.error.rose} />
  </TouchableOpacity>
);

export default AddProductTile;
